module.exports = __webpack_public_path__ + "media/activity-level/puppy-leisurely-e43cf52f.svg";